var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMasterCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_926_2046)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3538 1.6897H8.64648V13.6595H15.3538V1.6897Z",
    fill: "#FF5F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.47285 7.68029C9.47285 5.31046 10.5642 3.07229 12.3974 1.646C9.23974 -0.833539 4.7894 -0.471482 2.03444 2.46886C-0.678146 5.37629 -0.678146 9.98429 2.03444 12.8917C4.7894 15.843 9.23974 16.1941 12.3974 13.7146C10.5642 12.2883 9.48344 10.0501 9.47285 7.68029Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9999 7.67996C23.9787 10.6532 22.3045 13.3522 19.6873 14.592C17.0489 15.8756 13.9337 15.5465 11.6025 13.7252C14.8237 11.2347 15.4913 6.51699 13.086 3.18167C12.6621 2.60019 12.1641 2.08453 11.6025 1.64567C13.9337 -0.175585 17.0489 -0.504728 19.6873 0.778929C22.2939 2.0187 23.9787 4.7067 23.9999 7.67996Z",
    fill: "#F79E1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2693 12.4417V12.1894H23.3647V12.1345H23.1104V12.1894H23.2057V12.4417H23.2587H23.2693ZM23.7567 12.4417V12.1345H23.6825L23.5978 12.343L23.513 12.1345H23.4388V12.4417H23.4918V12.2113L23.5766 12.4088H23.6296L23.7143 12.2113V12.4417H23.7673H23.7567Z",
    fill: "#F79E1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_926_2046"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 15.36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCard);
export default __webpack_public_path__ + "static/media/MasterCard.8dac9db67892792f2e627a44095bce35.svg";
export { ForwardRef as ReactComponent };